import { Flex } from "@chakra-ui/react";
import { Outlet } from "react-router";

import { useSlugParam } from "@/common/hooks/useParam";
import { FeatureTargetingForm } from "@/feature/components/FeatureTargetingForm";
import { SetupInstructions } from "@/feature/components/SetupInstructions";
import { useFeatureData } from "@/feature/data/useFeatureData";

import FeatureSideBarWrapper from "../components/FeatureSidebarWrapper";

export default function FeatureTargeting() {
  const { featureId } = useSlugParam("feature");
  const { data: feature } = useFeatureData(featureId!);

  return (
    <FeatureSideBarWrapper>
      <Flex direction="column" flexGrow={1} h="full" px={6} py={4}>
        <SetupInstructions featureId={featureId} usecase="access" />
        {feature && <FeatureTargetingForm feature={feature} />}
        <Outlet />
      </Flex>
    </FeatureSideBarWrapper>
  );
}
